export default __webpack_public_path__ + "static/media/history-mobile-3.c6aa4b9e.png";